import { render, staticRenderFns } from "./Order_retail_customers.vue?vue&type=template&id=61f6b2a8&scoped=true&"
import script from "./Order_retail_customers.vue?vue&type=script&lang=js&"
export * from "./Order_retail_customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6b2a8",
  null
  
)

export default component.exports